import styled from "styled-components";

export const TabsContainer = styled.div`
  display: flex;
`;

export const Tab = styled.div`
  padding: 10px 20px;
  height: 36px;
  box-sizing: border-box;
  border-bottom: 2px solid
    ${({ isActive, accentColor, theme }) =>
      isActive ? accentColor : theme.border.black10};
  color: ${({ isActive, textColor, theme }) =>
    isActive ? textColor : theme.text.text};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
`;
